<template>
    <dynamic-vue-select
            label="type"
            :fetch-options-extra-config="{url: fetchDataUrl}"
            :fetch-options="fetchData"
            @input="(val) => $emit('input', val)"
            v-model="value"
            reduceKey="id"
            :multiple="multiple"
            :initialValue="initialValue"
    ></dynamic-vue-select>
</template>

<script>
    import store from '@/store'
    import { STORE_MODULE_NAME, STORE_MODULE_CONFIG}  from '../objectTypeStoreModule';

    import {ref, onBeforeMount, onBeforeUnmount} from '@vue/composition-api'


    import { InterfaceToDefaultStoreActions } from '@/store/utils/requests'
const { fetchData } = InterfaceToDefaultStoreActions()
    import DynamicVueSelect from '@core/components/dynamic-vue-select/DynamicVueSelect'
    import useObjectType from '../useObjectType'


    export default {

        components:{
            DynamicVueSelect
        },

        props: {
            initialValue: {
                type: Array,
                default: ()=>{
                    return []
                },
                required: false,
            },
            multiple:  {
                type: Boolean,
                default: false,
                required: false,
            },
        },


        setup(props) {

            // Re-register module with additional options
            onBeforeMount(() => {
                if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
            })


              // UnRegister on leave
            onBeforeUnmount(() => {
                if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
            })

            const value = ref([...props.initialValue])
            const { fetchDataUrl } = useObjectType()

            return {
                value,
                fetchData,
                fetchDataUrl
            }
        }
    }

</script>
